import { Component, inject } from '@angular/core';
import { FaunaSpecieService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FaunaSpecieCreateDto,
  FaunaSpecieDto,
  FaunaSpecieExcelDownloadDto,
  FaunaSpecieUpdateDto,
} from '../proxy/planning/dtos/fauna-specie';
import { FAUNASPECIE_CONFIG, FAUNASPECIE_FIELDS } from './fauna-specie.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-fauna-specie',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FaunaSpecieService, ConfirmationService],
  templateUrl: './fauna-specie.html',
  styleUrl: './fauna-specie.scss',
})
export class FaunaSpecie extends BaseCrudComponent<
  FaunaSpecieDto,
  FaunaSpecieCreateDto,
  FaunaSpecieUpdateDto,
  FaunaSpecieExcelDownloadDto
> {
  service = inject(FaunaSpecieService);
  config = FAUNASPECIE_CONFIG;
  fields = FAUNASPECIE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FaunaSpecieDto): FaunaSpecieUpdateDto {
    return {
      commonName: data.commonName,
      scientificName: data.scientificName,
      code: data.code,
      iucn: data.iucn,
      snapPriority: data.snapPriority,
      snapThreat: data.snapThreat,
      forestryThreat: data.forestryThreat,
      cites: data.cites,
      specieFamilyId: data.specieFamilyId,
      faunaClassId: data.faunaClassId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FaunaSpecie';
  }
}
